import Cookies from 'js-cookie';

const tokenKey = 'nlb_token';

export const CookieUtils = {
  setToken: (token: string) => Cookies.set(tokenKey, token, { expires: 7 }),
  getToken: () => Cookies.get(tokenKey),
  clearToken: () => Cookies.remove(tokenKey),
};
